import React from 'react';
import { Button, Box, Text } from 'rebass';
import PropTypes from 'prop-types';

const DetailHeaderButton = React.forwardRef(
  ({ icon, iconSize, iconcolor, label, size, labelProps, cursor = 'pointer', ...props }, ref) => {
    return (
      <Button
        variant="transparent"
        type="button"
        color="white"
        style={{ minHeight: size, minWidth: size }}
        css="display: flex; justify-content: flex-start; align-items: center;"
        sx={{
          borderRadius: 6,
          backgroundColor: "transparent",
          fontWeight: 'normal',
          cursor
        }}
        p={2}
        px={label === 'Back' ? 0 : 2}
        ref={ref}
        {...props}
      >
        {icon && <Box as={icon} color={iconcolor} size={iconSize} minWidth={iconSize} />}
        {label && (
          // <DisplayBox display={['none', 'none', 'inline-block']}>
          <Text color="white" px={1} fontSize="16px"
            textAlign="left"
            fontFamily='Poppins'
            lineHeight='100%'
            fontWeight={500}
            {...labelProps}>
            {label}
          </Text>
          // </DisplayBox>
        )}
      </Button>
    );
  }
);

DetailHeaderButton.propTypes = {
  icon: PropTypes.func.isRequired,
  iconSize: PropTypes.number,
  iconcolor: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.number,
};
DetailHeaderButton.defaultProps = {
  label: null,
  size: 40,
  iconSize: 24,
  iconcolor: 'white',
};

export default DetailHeaderButton;
